module.exports = __webpack_public_path__ + "img/cross_grey.995a8817.svg";